module.exports = __webpack_public_path__ + "media/newstyle/images/lp-banner-b-mobile-bba85215e4764e85778028c4ebadff40.png";